import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { colors } from "../../../ui/colors"
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left"
import { Layout } from "../../../ui/layout"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { Calendar } from "../../../ui/molecules/calendar"
import { MadfarmInput } from "../../../ui/molecules/input/newInput"
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../ui/molecules/textArea"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { EsitoBiosuisse, yes_no } from "../../../utils"
import { resetUpdateStatus, setEditCertificateDate, setEditCertificateExpires, setEditCertifiedProducts, setEditCondition, setEditDepartureProtocolSend, setEditEntryProtocolRequest, setEditEntryProtocolResponse, setEditInspectionVisitId, setEditNote, setEditNoteCondition, setEditResult, UpdateBioSuisse } from "./slice"

export function EditCertificazioneBiosuisse() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const bioSuisse = useAppSelector(state => state.bioSuisse)
    const assignmentState = useAppSelector(state => state.assignment)
    const [visitOptions, setVisitOptions] = useState<{ value: string; label: string }[]>([]);
    const [showSuccess, setShowSuccess] = useState<boolean>(false)


    useEffect(() => {
        if (assignmentState.getAllInspectionVisitStatus === 'successfully') {
            const visits = assignmentState.getAllInspectionVisitResponse?.data || [];
            const options = visits.map((visit) => ({
                value: visit.id,
                label: new Date(visit.effectiveVisitDate).toLocaleDateString('it-IT') + " " + (visit.reportProtocolInfo ? visit.reportProtocolInfo : ''),
            }));
            setVisitOptions(options);
        }
    }, [assignmentState.getAllInspectionVisitStatus]);

    useEffect(() => {
        if (bioSuisse.bioSuisseUpdateStatus === 'successfully') {
            setShowSuccess(true)
            dispatch(resetUpdateStatus())
        }
    }, [bioSuisse.bioSuisseUpdateStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
                navigate('/gestioneBioSuisse')
            }, 2500);
        }
    }, [showSuccess]);

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CLIENTI}
            breadcrumbItems={['Gestione Clienti', 'Gestione Biosuisse', 'Modifica Certificato']}
            noPaddingLat
            headerLabel="Modifica Certificato"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/gestioneBiosuisse')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-full w-full justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Modifica"
                        color={"orange"}
                        onClick={() => {
                            if (bioSuisse.idSelectedCert) {
                                dispatch(UpdateBioSuisse({ body: bioSuisse.editCertificate, id: bioSuisse.idSelectedCert }))
                            }
                        }}
                    />
                </div>
            }
        >
            {
                (showSuccess) &&
                <div className="mx-6 mb-2 mt-6 rounded-[12px] border border-[#86EFAC] bg-[#ECFDF3] px-5 py-4 text-left">
                    <span className="fieldsetTitle block text-[14px] font-semibold text-[#166534]">
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="p-6">
                <div className="rounded-[16px] border border-neutral-200 bg-white shadow-sm overflow-hidden">
                    <div className="bg-brandPrimary-600 px-6 py-4">
                        <div className='text-left'>
                            <span className='rid-title text-white'>Biosuisse </span>
                            <span className='rid-title text-brandPrimary-200'>/</span>
                            <span className='rid-title text-brandPrimary-100'> Modifica Certificazione Biosuisse</span>
                        </div>
                    </div>
                    <div className="p-6">
                        <div className='pb-6 border-b border-neutral-200'>
                            <ProtocolSearch
                                label="Richiesta Certificazione"
                                type='entry'
                                defaultValue={bioSuisse.editCertificate.certificationRequestId}
                                onSelect={(value) => {
                                    dispatch(setEditEntryProtocolRequest(value))
                                }} />
                        </div>
                        <div className='py-6 border-b border-neutral-200 grid grid-cols-1 md:grid-cols-2 gap-4'>
                            <MadfarmStaticSelect
                                label="Esito"
                                placeholder={'Esito'}
                                options={EsitoBiosuisse}
                                value={bioSuisse.editCertificate.result}
                                onChange={(value) => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setEditResult(newValue))
                                }}
                                noOptionsMessage={""}
                            />
                            <MadfarmStaticSelect
                                label="Controllo Bio Suisse"
                                placeholder={'Controllo Bio Suisse'}
                                value={bioSuisse.editCertificate.inspectionVisitId}
                                options={visitOptions}
                                onChange={(value) => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setEditInspectionVisitId(newValue))
                                }}
                                noOptionsMessage={"Nessun risultato trovato"}
                            />
                        </div>
                        <div className='py-6 border-b border-neutral-200 grid grid-cols-1 md:grid-cols-2 gap-4'>
                            <ProtocolSearch
                                label="Invio Checklist a Bio Suisse"
                                type='departure'
                                defaultValue={bioSuisse.editCertificate.sendingChecklistId}
                                onSelect={(value) => {
                                    dispatch(setEditDepartureProtocolSend(value))
                                }}
                            />
                            <ProtocolSearch
                                label="Certificato Bio Suisse"
                                type='entry'
                                defaultValue={bioSuisse.editCertificate.bioSuisseCertificateId}
                                onSelect={(value) => {
                                    dispatch(setEditEntryProtocolResponse(value))
                                }}
                            />
                        </div>
                        <div className='py-6 border-b border-neutral-200'>
                            <TextArea
                                label="Note"
                                onChangeText={(value) => dispatch(setEditNote(value))}
                                defaultValue={bioSuisse.editCertificate.note}
                            />
                        </div>
                        <div className='py-6 border-b border-neutral-200 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4'>
                            <MadfarmInput
                                label={'Prodotti Certificati'}
                                placeholder="Prodotti Certificati"
                                defaultValue={bioSuisse.editCertificate.certificatedProducts}
                                onChangeText={(text) => dispatch(setEditCertifiedProducts(text))}
                            />
                            <Calendar
                                label={'Data inizio validita certificato'}
                                selected={bioSuisse.editCertificate.validityStartingDate}
                                onChange={(date) => dispatch(setEditCertificateDate(date))}
                            />
                            <Calendar
                                label={'Data fine validita certificato'}
                                selected={bioSuisse.editCertificate.validityEndingDate}
                                onChange={(date) => dispatch(setEditCertificateExpires(date))}
                            />
                            <MadfarmStaticSelect
                                label="Condizioni per la certificazione"
                                value={bioSuisse.editCertificate.condition}
                                placeholder={'Condizioni per la certificazione'}
                                options={yes_no}
                                onChange={(value) => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setEditCondition(newValue === 'SI' ? true : newValue === 'NO' ? false : null))
                                }}
                                noOptionsMessage=""
                            />
                        </div>
                        <div className='pt-6'>
                            <TextArea
                                label="Dettaglio delle Condizioni per la certificazione"
                                onChangeText={(value) => dispatch(setEditNoteCondition(value))}
                                defaultValue={bioSuisse.editCertificate.certificationConditionsDetail}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout >
    )

}